/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// formik components
import { ErrorMessage, Field } from "formik";

// Material Dashboard 2 PRO React components
import { InputLabel } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

function FormField({ label, name, style, ...rest }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const combinedSx = {
    ...style,
    ...(darkMode ? {
      colorScheme: "dark",
      "& select": {
        colorScheme: "dark",
      },
      "& option": {
        backgroundColor: "#4B4F5C !important",
        color: "#ffffff !important",
      },
      "& .MuiNativeSelect-select option": {
        backgroundColor: "#4B4F5C !important",
        color: "#ffffff !important",
      }
    } : {})
  };

  return (
    <MDBox>
      <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>{label}</InputLabel>
      <Field {...rest} sx={combinedSx} name={name} as={MDInput} size="small" fullWidth />
      <MDBox mt={0.75}>
        <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
          <ErrorMessage name={name} />
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

// typechecking props for FormField
FormField.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FormField;
